import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressType, UserSubType } from '../../../appconfig';
import { CommonService } from '../../services/common';
import { IUserAddressRequestObject } from './user-address.model';
import { ToasterService } from '../../services/common/toaster.service';

@Component({
  selector: 'app-user-address',
  templateUrl: './user-address.component.html',
  styleUrl: './user-address.component.scss'
})
export class UserAddressComponent implements OnChanges {
  @Input() customerData: any;
  @Input() context: any;
  addressForm!: FormGroup;
  showAdressModal: boolean = false;
  Submitted = false;
  isCurrentAddress: boolean = false;
  addressToAndFromAddressDetail: any;
  isPermanentAndCurrentSame: any = null;
  showAddressIcon: any = true;
  isAddressDetailDialogOpen: boolean = true;
  showSubmitButton: boolean = true;

  modifiedAddresses: IUserAddressRequestObject[];

  constructor(private formBuilder: FormBuilder, private toasterService: ToasterService, private commonService: CommonService) {
    this.modifiedAddresses = [];
  }


  ngOnInit() {
    this.initiateForm();
    this.setAddressFormData(null);
    this.resetModifiedAddresses();
    if (this.context == 'allotmentContext') {
      this.showSubmitButton = false;
    } else {
      this.showSubmitButton = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!(changes['customerData'].isFirstChange())) {
      this.setAddressFormData(changes['customerData'].currentValue);
      this.resetModifiedAddresses();
    }
  }

  private resetModifiedAddresses() {
    this.modifiedAddresses = [];
    this.customerData?.addresses?.forEach((i: any) => {
      const obj = JSON.parse(JSON.stringify(i));
      this.fillAddressObject(obj, this.modifiedAddresses);
    })
  }


  /**
   * Initial addressForm controls
   */
  initiateForm() {
    this.addressForm = this.formBuilder.group({
      permanentAddress: ['', [Validators.required]],
      address: ['', [Validators.required]],
      officeAddress: ['']
    })
  }

  /**
   * created full address by concatination and also maked it blank if address is not coming form api end
   * @param address
   * @returns
   */
  createFullAddress(address: any) {
    return ((address?.address1) ? (address?.address1 + ', ') : '') + ((address?.city?.name) ? (address?.city?.name + ', ') : '')
      + ((address?.district?.name) ? (address?.district?.name + ', ') : '') + ((address?.state?.name) ? (address?.state?.name) : '') + ((address?.pinCode) ? ('-' + address?.pinCode) : '');
  }

  /**
   * mapping the addresstype
   * @param type
   * @returns
   */
  getAddressByType(type: AddressType) {
    const currentCustomer = this.customerData?.currentRecord ? this.customerData?.currentRecord : this.customerData;

    const address = currentCustomer?.addresses?.find((addr: any) => addr?.assressType?.id === type);

    if (!address) {
      return { addressType: { id: type, name: AddressType[type].toString() } }
    } else {
      return address;
    }
  }

  /**
   * setting the addressmetadata and populated on ui
   * @param customerData
   */
  setAddressFormData(customerData: any) {
    this.customerData = customerData ?? this.customerData;
    if (this.customerData) {
      let fullAddress = '';
      if (this.getAddressByType(AddressType.Current)) {
        const address = this.getAddressByType(AddressType.Current);
        fullAddress = this.createFullAddress(address)
        this.addressForm.controls['address'].setValue(fullAddress);

      }
      if (this.getAddressByType(AddressType.Permanent)) {
        const address = this.getAddressByType(AddressType.Permanent);
        fullAddress = this.createFullAddress(address)
        this.addressForm.controls['permanentAddress'].setValue(fullAddress);
      }
      if (this.getAddressByType(AddressType.Office)) {
        const address = this.getAddressByType(AddressType.Office);
        fullAddress = this.createFullAddress(address)
        this.addressForm.controls['officeAddress'].setValue(fullAddress);
      }

      if (this.addressToAndFromAddressDetail) {
        this.addressToAndFromAddressDetail.fullAdress = fullAddress;
      }
    }
  }

  //opening a modal
  openModal(addressType: any): void {

    this.setAddressmetaData(addressType);
    // this.adressMetaData.fullAdress = '';
    //If selected addressType current then Modal Label should Be Current Address
    let address: any = {};
    address = this.getAddressByType(addressType);
    if (addressType == AddressType.Current) {
      this.isCurrentAddress = false;
      this.addressToAndFromAddressDetail.addressLabel = 'Current';
    }
    //If selected addressType Permanent then Modal Label should Be Permanent Address
    else if (addressType == AddressType.Permanent) {
      this.addressToAndFromAddressDetail.addressLabel = 'Permanent';
    }
    //If selected addressType Office then Modal Label should Be Office Address
    else {
      this.addressToAndFromAddressDetail.addressLabel = 'Office';
    }
    this.addressToAndFromAddressDetail.addressType = address.addressType ?? address.assressType;
    this.addressToAndFromAddressDetail.address = address;
    this.addressToAndFromAddressDetail.fullAdress = this.createFullAddress(address);
    this.isAddressDetailDialogOpen = true;
    this.showAdressModal = true;
  }


  /**
   * returns the form control after
   */
  get f(): { [key: string]: AbstractControl } {
    return this.addressForm.controls;
  }

  /**
 * method used to display permanent address if Current adrress is same as permanent address
 */
  setPermanantAddressAsCurrent(event: Event) {

    //If checkbox is selected then Permanent Address is same as Current Address
    if ((event.currentTarget as HTMLInputElement).checked) {
      this.showAddressIcon = false;
      // this.adressMetaData = undefined;
      this.isPermanentAndCurrentSame = true;
      // this.adressMetaData = {};
      const fullAddress = (this.isPermanentAndCurrentSame) ? this.addressForm?.value?.address : '';
      this.addressForm.controls['permanentAddress'].setValue(fullAddress);
    }
    //Else Permanent Address have add mannual using Address Modal
    else {
      this.showAddressIcon = true;
      this.isPermanentAndCurrentSame = false;
      if (this.addressToAndFromAddressDetail) {
        this.addressToAndFromAddressDetail.fullAdress = '';
      }
      this.addressForm.controls['permanentAddress'].setValue('');

    }

  }

  /**
   * We are getting data of fullAddress(Concatinated) on the behalf of AddressType which is confirmed from AddressType
   * @param address In this metadata we are using AddressType here to check which type of address we want to get in input
   */
  close(address: any) {
    if (address && address.addressType) {
      this.addressToAndFromAddressDetail = address;
      this.showAddressIcon = true;
      this.showAdressModal = false;
      this.addressToAndFromAddressDetail.fullAdress = address.fullAdress;
      //this.addressToAndFromAddressDetail.fullAdress = this.addressForm.controls['address'].value


      if (this.isPermanentAndCurrentSame
        && ((address.addressType.id === AddressType.Current) || (address.addressType.id === AddressType.Permanent))) {
        const copyOfAddress = JSON.parse(JSON.stringify(this.addressToAndFromAddressDetail));
        if (address.addressType.id === AddressType.Current) {
          copyOfAddress.addressType.id = AddressType.Permanent;
          copyOfAddress.addressType.name = AddressType[AddressType.Permanent];
        } else if (address.addressType.id === AddressType.Permanent) {
          copyOfAddress.addressType.id = AddressType.Current;
          copyOfAddress.addressType.name = AddressType[AddressType.Current];
        }

        this.fillAddressObject(copyOfAddress, this.modifiedAddresses);
      } else {  // office address modified
        // nothing to do here.
      }


      //Set the value in Current AddressInput if addressType is current requested
      if (address.addressType?.id == AddressType.Current) {
        this.addressForm.controls['address'].setValue(address.fullAdress);
      }
      //Set the value in Permanent AddressInput if addressType is Permanent requested
      else if (address.addressType?.id == AddressType.Permanent) {
        this.addressForm.controls['permanentAddress'].setValue(address.fullAdress);
      }
      //Set the value in Office AddressInput if addressType is Office requested
      else {
        this.addressForm.controls['officeAddress'].setValue(address.fullAdress);
      }
      this.fillAddressObject(this.addressToAndFromAddressDetail, this.modifiedAddresses);

    }
  }

  /**
   * set the formControls as a request metadata
   * @param addressType parameter is passed AddressType as a requested Parameter for which type of address we want data
   */
  setAddressmetaData(addressType: any) {
    this.addressToAndFromAddressDetail = undefined;
    this.addressToAndFromAddressDetail = {
      "addressLabel": '',
      "subTypeId": UserSubType.Client,
      "addressType": addressType,
      "address": {
        "address1": '',
        "cityId": '',
        "village": '',
        "stateId": '',
        "Pincode": ''
      },
      "fullAdress": ''
    }
  }


  fillAddressObject(sourceObj: any, targetArray: IUserAddressRequestObject[]) {
    const result = <IUserAddressRequestObject>{
      userId: (this.customerData?.id) ?? null,
      addressTypeId: (sourceObj?.addressType?.id) ?? ((sourceObj?.addressType?.id) ? (sourceObj?.addressType?.id) : null),
      address1: sourceObj?.address?.address1 ?? (sourceObj?.address?.address1 ?? null),
      address2: sourceObj?.address?.address2 ?? (sourceObj?.address?.address2 ?? null),
      pinCode: sourceObj?.address?.pinCode ?? sourceObj?.address?.pinCode,
      cityId: sourceObj?.address?.city?.id ?? (sourceObj?.address?.city.id ? sourceObj?.address?.city.id : null),
      villageId: sourceObj.address?.village?.id ?? (sourceObj?.address?.village?.id ? sourceObj?.address?.village.id : null),
      isActive: sourceObj?.isActive ?? true
    };


    targetArray = targetArray ?? [];
    const elem = targetArray.find((i: IUserAddressRequestObject) => (i.addressTypeId === sourceObj.addressType?.id || i.addressTypeId === sourceObj.assressType?.id));

    if (elem) {
      const index = targetArray.indexOf(elem);
      targetArray.splice(index, 1);
    }

    targetArray.push(result);
  }

  /**
   * onSubmitting the address for , in this we have defined the payload request and update the address
   */
  onSubmit() {
    const payload = this.modifiedAddresses;
    this.commonService.addressupdate(this.customerData?.id, payload).subscribe((res: any) => {
      this.toasterService.showSuccess("Address is updated Successfully")
    })
  }
}
